import type { ReactNode, Ref } from 'react';
import styles from './PageHeader.module.css';

/**
 * A page's header (Jason, 16 Oct): its icon in a square, its title, a line on
 * what the page is only where that helps, and its own controls on the right;
 * then a rule, and the page under it (a page's tabs included). The same sizes
 * and spacing as the inbox and All projects headers, so every page opens
 * alike.
 */
export function PageHeader({ icon, title, subtitle, actions, testId, headingRef }: {
  icon: ReactNode; title: string; subtitle?: ReactNode; actions?: ReactNode; testId?: string;
  /** The title, for a page that sends focus to it when the control that had focus has gone. */
  headingRef?: Ref<HTMLHeadingElement>;
}) {
  return (
    <header className={styles.header} data-testid={testId}>
      <div className={styles.row}>
        <div className={styles.iconSlot} aria-hidden="true">{icon}</div>
        <div className={styles.text}>
          {/* Focusable by script only (tabIndex -1), for headingRef. */}
          <h1 ref={headingRef} className={styles.title} tabIndex={-1}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
    </header>
  );
}

/** The soft gradient the walkthrough page opened with, for any page behind its header (Jason, 16 Oct). */
export const pageBackground = styles.pageBackground;
